import { ImageGallery } from '@src/components/ImageGallery';
import { CardsSkeleton } from '@src/components/Loading/CardsSkeleton';
import {
  ROUTE_PACKAGE_BASE_URL,
  ROUTE_STORE_FULL_URL,
} from '@src/constants/URLS.const';
import { useGetCountriesQuery } from '@src/services/country/countryApiSlice';
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';

export function PopularCountries() {
  const navigate = useNavigate();

  const { data, isLoading } = useGetCountriesQuery({ includeRegion: true });

  const top5Countries = (data ? [...data] : [])
    .sort((a, b) =>
      a.clickCount && b.clickCount ? b.clickCount - a.clickCount : 0
    )
    .slice(0, 5);

  const handleCountryClick = (countryId: string) => {
    navigate(`${ROUTE_PACKAGE_BASE_URL}?countryId=${countryId}`);
  };

  if (isLoading)
    return (
      <div className='!mt-6'>
        <CardsSkeleton numberOfItems={3} />;
      </div>
    );

  return (
    <div className='custom-scrollbar !mt-6'>
      <div className='flex justify-between items-center px-1 mb-4'>
        <span className='font-bold text-M-20 text-wl-on-background'>
          Popular Destinations
        </span>
        <Button
          className='border-none p-0 text-M-14 text-wl-primary bg-transparent hover:!bg-transparent hover:!text-wl-primary'
          variant='text'
          onClick={() => navigate(ROUTE_STORE_FULL_URL)}
        >
          See All
        </Button>
      </div>
      {top5Countries && (
        <ImageGallery
          images={top5Countries.map((country) => ({
            id: country.id,
            src: country.popularImage,
            title: country.name,
          }))}
          onImageClick={handleCountryClick}
        />
      )}
    </div>
  );
}
